import React, { FC } from 'react';
import * as Styled from './styles';

interface IProps {
    isLoading: boolean;
    text: string;
}

const LoadingMessage: FC<IProps> = ({ isLoading, text }) => (
    <Styled.Wrapper>
        <Styled.Icon icon="spinner-third" spin={isLoading} />
        <Styled.Text>{text}</Styled.Text>
    </Styled.Wrapper>
);

export default LoadingMessage;
